import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React from "react";
import "./style.css";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableCell: {
    maxWidth: 170,
  },
}));

function TableComponent(props) {

  const { data, columns } = props;

  const classes = useStyles();

  return (
    <Grid>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell align="center" key={column.field}>
                {column.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => {
            return (
              <TableRow key={row.id} hover onClick={() => { }}>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    style={{
                      paddingRight: 0,
                      position: "relative",
                    }}
                    className={classes.tableCell}
                  >
                    {row[column.field]}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
}

export default TableComponent;
